import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateRunsheet from "../pages/Runsheet/CreateRunsheet";
import EditRunsheet from "../pages/Runsheet/EditRunsheet";
import RunsheetList from "../pages/Runsheet/RunsheetList";
//@ts-ignore
import {
  PermissionRequired,
  AccessControl,
} from "@careinfo/permission-required";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessControl
                children={<RunsheetList />}
                allowedPermissions={["can_view_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/runsheet"
            element={
              <AccessControl
                children={<RunsheetList />}
                allowedPermissions={["can_view_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />

          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateRunsheet />}
                allowedPermissions={["can_create_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditRunsheet />}
                allowedPermissions={["can_view_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
